/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CloseCircle: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM7.35539 7.35539C6.96487 7.74592 6.96487 8.37908 7.35539 8.76961L10.5858 12L7.35539 15.2304C6.96487 15.6209 6.96487 16.2541 7.35539 16.6446C7.74592 17.0351 8.37908 17.0351 8.76961 16.6446L12 13.4142L15.2304 16.6446C15.6209 17.0351 16.2541 17.0351 16.6446 16.6446C17.0351 16.2541 17.0351 15.6209 16.6446 15.2304L13.4142 12L16.6446 8.76961C17.0351 8.37908 17.0351 7.74592 16.6446 7.35539C16.2541 6.96487 15.6209 6.96487 15.2304 7.35539L12 10.5858L8.76961 7.35539C8.37908 6.96487 7.74592 6.96487 7.35539 7.35539Z'
      fill='currentColor'
    />
  </React.Fragment>
)
